import { render } from "./FileDropArea.vue?vue&type=template&id=b6299ce2&scoped=true"
import script from "./FileDropArea.vue?vue&type=script&lang=js"
export * from "./FileDropArea.vue?vue&type=script&lang=js"

import "./FileDropArea.vue?vue&type=style&index=0&id=b6299ce2&scoped=true&lang=css"

import exportComponent from "../../../../biotron-complaint-20260813/WebMidiVue-integrated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6299ce2"]])

export default __exports__